import { ReactNode, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import i18n from "../i18n/config";

interface LanguageProviderProps {
  children: ReactNode;
}

const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();

  useEffect(() => {
    const handleLanguageChange = async () => {
      try {
        const currentLang = lang || "en";
        if (["en", "de", "es", "fr", "it"].includes(currentLang)) {
          await i18n.changeLanguage(currentLang);
        } else {
          navigate("/en", { replace: true });
        }
      } catch (error) {
        console.error("Error changing language:", error);
      }
    };

    handleLanguageChange();
  }, [lang, i18n, navigate]);

  return <>{children}</>;
};

export default LanguageProvider;
